<div class="menu-tabs">
    <nav class="tab-header">
        <a [routerLink]="['main']" routerLinkActive="active-tab" class="tab-link">{{ 'NAV.MENU' | translate }}</a>
        <a *ngIf="hasSpecialInstructionView$ | async"
           [routerLink]="['special-instructions']" routerLinkActive="active-tab" class="tab-link"
        >{{ 'MENU.SPECIAL_INSTRUCTIONS.TAB' | translate }}</a>
    </nav>
</div>

<router-outlet></router-outlet>
